import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Edit_Complaints.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  allNatureComplaints,
  allSampleManagement,
  AllCustomer,
  allComplaintStatus,
} from "../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import {
  GetSingle,
  Update,
  GetAll,
} from "../../../../../../../../src/features/admin/quality_management/process_requirement/complaint/Slice";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Edit_Complaints({ id, onCancel }) {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [success, setSuccess] = useState(false);

  const singleComplaint = useSelector((state) => state.complaint.single);

  const complaintData = Array.isArray(singleComplaint)
    ? singleComplaint[0]
    : singleComplaint;

  const all_complaint_status = useSelector(
    (state) => state.common.all_complaint_status,
  );
  const all_nature_complaints = useSelector(
    (state) => state.common.all_nature_complaints,
  );
  const all_sample_management = useSelector(
    (state) => state.common.all_sample_management,
  );
  const all_customer = useSelector((state) => state.common.all_customer);

  useEffect(() => {
    if (id) dispatch(GetSingle(id));
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(allComplaintStatus());
    dispatch(allNatureComplaints());
    dispatch(allSampleManagement());
    dispatch(AllCustomer());
  }, [dispatch]);

  useEffect(() => {
    if (!complaintData) return;

    setValue("customer_name", complaintData.customer_name || "");
    setValue("contact_person_name", complaintData.contact_person_name || "");
    setValue(
      "contact_person_contact_no",
      complaintData.contact_person_contact_no || "",
    );
    setValue("contact_person_email", complaintData.contact_person_email || "");
    setValue("remark", complaintData.remark || "");

    setValue("nature_of_complaint_id", complaintData.nature_of_complaint_id);
    setValue("sample_management_id", complaintData.sample_management_id);
    setValue("users_id", complaintData.users_id);

    setValue("complaint_status_id", String(complaintData.complaint_status_id));
  }, [complaintData, setValue]);

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("sample_management_id", data.sample_management_id);
    formData.append("complaint_status_id", data.complaint_status_id);

    formData.append("users_id", data.users_id);

    formData.append("customer_name", data.customer_name);
    formData.append("contact_person_name", data.contact_person_name);
    formData.append(
      "contact_person_contact_no",
      data.contact_person_contact_no,
    );
    formData.append("contact_person_email", data.contact_person_email);
    formData.append("remark", data.remark);

    // if (data.attach_file instanceof File) {
    formData.append("attach_file", data.image[0]);
    // Object.keys(data).forEach((key) => {
    //   formData.append(key, data[key]);
    // });

    const res = await dispatch(Update({ id, sendData: formData }));

 console.log(data,"edit resaponse");

    if (res.meta.requestStatus === "fulfilled") {
      setSuccess(true);
      onCancel();
      dispatch(GetAll());
    }
  };

 

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            {/* Sample ID */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Sample ID</Form.Label>
                <Controller
                  name="sample_management_id"
                  control={control}
                  render={({ field }) => (
                    <Select
                      options={all_sample_management}
                      value={
                        all_sample_management?.find(
                          (o) => o.value === field.value,
                        ) || null
                      }
                      onChange={(e) => field.onChange(e?.value)}
                    />
                  )}
                />
              </Form.Group>
            </div>

            {/* Customer Name */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Customer Name</Form.Label>
                <Form.Control {...register("customer_name")} />
              </Form.Group>
            </div>

            {/* Customer ID */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Customer ID</Form.Label>
                <Controller
                  name="users_id"
                  control={control}
                  render={({ field }) => (
                    <Select
                      options={all_customer}
                      value={
                        all_customer?.find((o) => o.value === field.value) ||
                        null
                      }
                      onChange={(e) => field.onChange(e?.value)}
                    />
                  )}
                />
              </Form.Group>
            </div>

            {/* Contact Person */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Contact Person Name</Form.Label>
                <Form.Control {...register("contact_person_name")} />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Contact No.</Form.Label>
                <Form.Control {...register("contact_person_contact_no")} />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Email</Form.Label>
                <Form.Control {...register("contact_person_email")} />
              </Form.Group>
            </div>

            {/* Nature Of Complaint */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Nature Of Complaint</Form.Label>
                <Controller
                  name="nature_of_complaint_id"
                  control={control}
                  render={({ field }) => (
                    <Select
                      options={all_nature_complaints}
                      value={
                        all_nature_complaints?.find(
                          (o) => o.value === field.value,
                        ) || null
                      }
                      onChange={(e) => field.onChange(e?.value)}
                    />
                  )}
                />
              </Form.Group>
            </div>

            {/* Action Taken (RADIO – FIXED) */}
            <div className="col-md-12">
              <Form.Group className="form_group">
                <Form.Label>Action Taken:</Form.Label>
                {all_complaint_status?.map((status) => (
                  <Form.Check
                    key={status.value}
                    type="radio"
                    label={status.label}
                    value={String(status.value)}
                    {...register("complaint_status_id")}
                  />
                ))}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group file_field">
                <Form.Label>Attach Document (Optional)</Form.Label>

                <div className="absolute_fields">
                  <Form.Control
                    type="file"
                    {...register("image", {
                      // required:
                      //   typeof getValues("image") === "string"
                      //     ? false
                      //     : "File is required",
                    })}
                    accept="*"
                  />
                  <div className="upload_icon_holder">
                    <FontAwesomeIcon icon={faUpload} />
                  </div>
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </div>
                {(() => {
                  const fileValue = watch("image");

                  // URL for preview
                  const fileUrl =
                    typeof fileValue === "string"
                      ? process.env.REACT_APP_IMG_URL + fileValue
                      : fileValue?.length > 0
                      ? URL.createObjectURL(fileValue[0])
                      : null;

                  // Type detection
                  const fileType =
                    typeof fileValue === "string"
                      ? fileValue.toLowerCase()
                      : fileValue?.[0]?.type;

                  if (!fileUrl) return null;

                  return (
                    <div className="image_holder">
                      {/* IMAGE */}
                      {(fileType?.includes("image") ||
                        fileType?.endsWith(".jpg") ||
                        fileType?.endsWith(".jpeg") ||
                        fileType?.endsWith(".png")) && (
                        <img
                          src={fileUrl}
                          alt="Preview"
                          className="image-preview"
                          style={{ maxWidth: "100px" }}
                        />
                      )}

                      {/* PDF */}
                      {(fileType === "application/pdf" ||
                        fileType?.endsWith(".pdf")) && (
                        <iframe
                          src={fileUrl}
                          style={{ maxWidth: "100px" }}
                          title="PDF"
                        />
                      )}

                      {/* WORD */}
                      {(fileType?.includes("word") ||
                        fileType?.endsWith(".doc") ||
                        fileType?.endsWith(".docx")) && (
                        <div>
                          <p>Word preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Word File
                          </a>

                          <iframe
                            src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                            style={{ maxWidth: "100px" }}
                            title="Word Preview"
                          />
                        </div>
                      )}

                      {/* EXCEL */}
                      {(fileType?.includes("spreadsheet") ||
                        fileType?.endsWith(".xlsx") ||
                        fileType?.endsWith(".xls")) && (
                        <div>
                          <p>Excel preview not supported</p>
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open / Download Excel File
                          </a>
                        </div>
                      )}
                    </div>
                  );
                })()}
                {/* {filePreview && (
                <div className="image_holder">
                  <img
                    src={filePreview}
                    alt="Preview"
                    className="img_preview"
                  />
                </div>
              )} */}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Remark</Form.Label>
                <Form.Control {...register("remark")} />
              </Form.Group>
            </div>

            <div className="row">
              {complaintData?.Complaints_Files?.length > 0 &&
                complaintData.Complaints_Files.map((file, i) => {
                  const fileUrl = process.env.REACT_APP_IMG_URL + file?.file;
                   const fileType = file?.file ? file.file.toLowerCase() : "";

                  return (
                    <div className="col-md-3 mb-3" key={i}>
                      <div className="image_holder">
                        <div>{file?.Complaint_Status?.name}</div>

                        {/* IMAGE */}
                        {(fileType.includes("image") ||
                          fileType.endsWith(".jpg") ||
                          fileType.endsWith(".jpeg") ||
                          fileType.endsWith(".png")) && (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            className="image-preview img-fluid"
                            style={{ maxWidth: "100px" }}
                          />
                        )}

                        {/* PDF */}
                        {fileType.endsWith(".pdf") && (
                          <iframe
                            src={fileUrl}
                            title="PDF Preview"
                            style={{ maxWidth: "100px" }}
                          />
                        )}

                        {/* WORD */}
                        {(fileType.endsWith(".doc") ||
                          fileType.endsWith(".docx")) && (
                          <div>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              📄 Open Word File
                            </a>

                            <iframe
                              src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                              style={{ maxWidth: "100px" }}
                              title="Word Preview"
                            />
                          </div>
                        )}

                        {/* EXCEL */}
                        {(fileType.endsWith(".xls") ||
                          fileType.endsWith(".xlsx")) && (
                          <div>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              📊 Open Excel File
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button className="permission_btn No_btn" onClick={onCancel}>
                  Reset
                </Button>
                <Button type="submit" className="permission_btn Yes_btn">
                  Save
                </Button>
              </>
            )}
          </div>
        </form>
      </div>
    </section>
  );
}

export default Edit_Complaints;
